import useTranslation from 'next-translate/useTranslation';

// Lib
import { GROUPS, SOCIAL_PROFILES } from '@/lib/routes/privateRoutes';

// Utils
import { useUserGroupRestriction } from '@/utils/hooks/acl/useUserGroupRestriction';

// Components
import H2 from '@/components/base/Headings/H2';
import NavTabsLinks from '@/components/composite/NavTabs/NavTabLinks';
import { TooltipPlanRestrictionContent } from '@/components/layouts/LayoutPlatform/components/Menu/components/TooltipPlanRestriction';

// Types
import type { ReactNode } from 'react';
import type { NavTabsLinksTabType } from '@/components/composite/NavTabs/NavTabLinks';

type ManageProfilesHeaderProps = { children?: ReactNode };

export function ManageProfilesHeader({ children }: ManageProfilesHeaderProps) {
    const { t } = useTranslation('commons');
    const { hasGroupPermission } = useUserGroupRestriction();
    const links: NavTabsLinksTabType[] = [
        {
            name: t('groups'),
            icon: 'group',
            iconActive: 'group-on',
            id: 'groups',
            url: GROUPS,
            disabled: !hasGroupPermission,
            tooltip: <TooltipPlanRestrictionContent />
        },
        {
            name: t('social_profiles'),
            icon: 'single-profile',
            iconActive: 'single-profile-on',
            id: 'social_profiles',
            url: SOCIAL_PROFILES
        }
    ];
    return (
        <>
            <header className="mb-4 pb-4">
                <H2>{t('manage_profiles')}</H2>
            </header>
            <div className="mb-5 flex flex-col justify-between space-y-5 @xl/wrapper-platform-content:flex-row @xl/wrapper-platform-content:space-y-0">
                <NavTabsLinks tabs={links} />
                {children}
            </div>
        </>
    );
}
